import { createFileRoute } from "@tanstack/react-router";
import { comparisonRoute } from "@/lib/seo/comparisonRoute";
import { getComparison } from "@/lib/seo/comparisons";

export const Route = createFileRoute("/jamfor/video-as-a-service-vs-filmbyra")(
  comparisonRoute(getComparison("video-as-a-service-vs-filmbyra")),
);
